let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bjotz")).then(() => parcelRequire('cqziN'));